//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export const DEFAULT_COLORS_PINK = {
    color: [
        'var(--ods-pink-1, #BC4D9A)',
        'var(--ods-pink-2, #D573BB)',
        'var(--ods-pink-3, #FF8AD4)',
        'var(--ods-pink-4, #FFB4E6)',
        'var(--ods-pink-5, #FFCEEF)',
        'var(--ods-pink-6, #FFE8F7)',
    ],
};
